import { tagTypes } from 'lib/src/shared/enums/tagTypes';

export const getTagRouteEndpoint = (type: tagTypes) =>
    type === tagTypes.tag ? 'tags/challenge' : 'tags/business';
